import restApi from "@plannel/services/utils/rest-api";

const getAppConfigs = params => {
  return restApi.get("/api/app-config", { params });
}

const getAppConfigObjVal = configCd => {
  return restApi.get(`/api/app-config/${configCd}`);
}

const upsertAppConfig = data => {
  return restApi.post("/api/app-config", data);
}

const upsertAppConfigByCd = ({ saveData, configCd })  => {
  return restApi.post(`/api/app-config/${configCd}`, saveData, configCd);
}

/* Message: [MSG_MonthlyTransformRequired, MSG_MonthlyTransformUpdateRequired] */
const asyncCheckMonthlyPSIData = async () => {
  let message = "";
  await restApi.get("/api/app-config/check-monthly-psi-data")
  .then(response => {
    message = response.data;
  }).catch(error => {
    message = error?.response?.data ? error.response.data : "Monthly PSI Check Error";
    console.warn("error: ", error);
  });

  return message;
}

const appConfigService = {
  getAppConfigs,
  getAppConfigObjVal,
  upsertAppConfig,
  upsertAppConfigByCd,
  asyncCheckMonthlyPSIData
}

export default appConfigService;